<!--
 * @Author: jzh
 * @Date: 2020-11-17 16:59:24
 * @LastEditors: DQL
 * @LastEditTime: 2022-09-26 22:07:46
 * @Description: 用户关联岗位，单身份显示用户名称，用户编码，使用用户编码（身份编码）来关联岗位
-->

<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-70 o-dialog--xl-50"
    title="用户关联岗位"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :inline="true"
        label-position="right"
        label-width="110px"
        label-suffix="："
      >
        <el-row class="c-form__row">
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="用户编码"
              prop="userCode"
            >
              <span class="c-form__read">
                {{ userCode }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="用户名称"
              prop="userName"
            >
              <span class="c-form__read">
                {{ userName }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="所属组织"
              prop="deptName"
            >
              <span class="c-form__read">
                {{ deptName }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-transfer
              v-model="fd.deptRoleUuid"
              class="c-form__transfer c-flex-transfer"
              filterable
              filter-placeholder="请输入岗位名称"
              :filter-method="filterMethod"
              :titles="['可选岗位','已选岗位']"
              :render-content="renderFunc"
              :props="transferProps"
              :data="roleList"
            />
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <el-button
        type="primary"
        @click="handleSave()"
      >
        保存
      </el-button>
      <el-button @click="closeDialog()">
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { roleCapacityService } from '../user.service';

export default {
  name: 'SingleRelateRole',
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示

      loading: false, // 页面loading状态

      /* 表单参数 Start */
      fd: {
        capacityCode: null, // 用户身份uuid
        deptRoleUuid: [] // 已关联岗位uuid
      },
      /* 表单参数 End */

      /* 穿梭框配置 Start */
      roleList: [], // 岗位列表
      // 穿梭框参数配置
      transferProps: {
        key: 'deptRoleUuid',
        label: 'roleName'
      },
      // 穿梭框过滤方法
      filterMethod (query, item) {
        return item.roleName.indexOf(query) > -1 || item.roleCode.indexOf(query) > -1;
      },
      // 自定义穿梭框展示内容
      renderFunc (h, option) {
        return <span>{option.roleName}（{option.roleCode}）</span>;
      },
      /* 穿梭框配置 End */

      userCode: null, // 用户编码
      userName: null, // 用户名称
      deptName: null // 机构部门名称

    };
  },
  methods: {
    /**
     * @description: 查询所有可关联岗位列表
     * @param {*}
     * @return {*}
     */
    getRoleList () {
      this.loading = true;
      roleCapacityService.getWglRoleList(this.fd.capacityCode, this.dlParams.deptCode)
        .then(rsp => {
          this.roleList = rsp.data.list;
        })
        .catch(err => {
          console.error('查询岗位错误', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 查询已关联岗位列表
     * @param {*}
     * @return {*}
     */
    getYglRoleList () {
      roleCapacityService.getYglRoleList(this.fd.capacityCode)
        .then(rsp => {
          const roleList = rsp.data.list;
          this.fd.deptRoleUuid = roleList.map((item) => {
            return item.deptRoleUuid;
          });
        })
        .catch(err => {
          console.error('查询已关联岗位错误', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 岗位关联保存操作
     * @param {*}
     * @return {*}
     */
    handleSave () {
      this.$refs.fd.validate((valid) => {
        if (valid) {
          this.loading = true;
          roleCapacityService.save(this.fd)
            .then(rsp => {
              this.$alert('关联成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
              this.$emit('closeDialog', '');
              this.$emit('callback');
            })
            .catch(err => {
              console.log('岗位关联保存错误', err);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    }
  },
  created () {
    this.fd.capacityCode = this.dlParams.userCode;
    this.userCode = this.dlParams.userCode;
    this.userName = this.dlParams.userName;
    this.deptName = this.dlParams.deptName;
  },
  mounted () {
    this.getRoleList();
    this.getYglRoleList();
  }
};
</script>
